const Button = ({ onClick, text, loading }) => {
  return (
    <div className="flex justify-center items-center w-full"> {/* Centering Wrapper */}
      <button
        onClick={onClick}
        className="relative p-0 bg-transparent border-0 cursor-pointer w-40 lg:w-48 flex justify-center items-center"
        disabled={loading}
      >
        <img
          src="images/buttonImage.png"
          alt="button"
          className="w-full h-full pointer-events-none"
        />
        <span className="absolute text-black font-semibold lg:text-lg text-[16px] pointer-events-none">
          {text}
        </span>
      </button>
    </div>
  );
};

export default Button;
